import React, { CSSProperties, useEffect, useState } from "react";
import "./switch.less";

type SwitchValue = boolean | "empty";

interface SwitchProps {
   checked?: SwitchValue;
   defaultChecked?: SwitchValue;
   className?: string;
   disabled?: boolean;
   readOnly?: boolean;
   id?: string;
   onChange?: (e: boolean) => void;
   onStartEdit?: () => void;
   size?: "default" | "small";
   label?: string;
   label2?: string;
   customLabelStyle?: CSSProperties;
   customLabel2Style?: CSSProperties;
   customBackgroundColor?: string;
}

export const Switch: React.FC<SwitchProps> = ({
   checked,
   defaultChecked = false,
   className = "",
   disabled = false,
   readOnly = false,
   onChange,
   onStartEdit,
   size = "default",
   label = "",
   label2 = "",
   customLabelStyle = {},
   customLabel2Style = {},
   customBackgroundColor,
   id,
}) => {
   const isControlled = typeof checked !== "undefined";
   const [value, setValue] = useState<SwitchValue>(isControlled ? checked : defaultChecked);

   useEffect(() => {
      if (typeof checked !== "undefined") {
         setValue(checked);
      }
   }, [checked]);

   const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
      const isChecked = e.target.checked;
      if (!isControlled) {
         setValue(isChecked);
      }
      onChange?.(isChecked);
   };

   return (
      <label
         style={{
            width: "60px",
            backgroundColor: `${value !== "empty" ? customBackgroundColor : undefined}`,
         }}
         data-testid="switch-element"
         className={`bp2-switch ${className} bp2-switch-${size}`}
      >
         {value === "empty" ? null : (
            <>
               <input
                  id={id}
                  data-testid="switch-input"
                  type="checkbox"
                  checked={value}
                  onChange={!readOnly ? handleChange : () => {}}
                  disabled={disabled}
                  readOnly={readOnly}
                  onClick={readOnly ? onStartEdit : undefined}
               />
               <span
                  data-testid="switch-span"
                  className={`${disabled ? "switch-disabled" : ""} slider round`}
               ></span>
               {value ? (
                  <span style={customLabelStyle}>{label}</span>
               ) : (
                  <span style={customLabel2Style}>{label2}</span>
               )}
            </>
         )}
      </label>
   );
};
